// test1060
(1060 && 0);
